import ReactDOM from "react-dom";
import BaseComponent from "../../../baseComponent.js";
import Chart from "./chart.jsx";
import Legends from "./legend/legends.jsx";
import Tooltip from "./tooltip/tooltip.jsx";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import WidgetService from "../../../../core/services/widgetService";

export default class TimeSeriesWidget extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      legends: null
    }
  }

  componentDidMount() {
    this.subscribe(InternalEvent.Widget.REALTIME_RESUMED, payload => {

      this.publish(InternalEvent.Dashboard.UPDATE_DASHBOARD_STATE);

      this.resetWidget(payload);
    });
    this.renderToolTip();
  }

  componentWillUnmount() {
    this.unsubscribeAll();
    ReactDOM.unmountComponentAtNode(document.getElementById(this.tooltipId));
  }

  renderToolTip() {
    this.tooltipId = "tooltip-" + this.props.model.id;
    $("#tooltips-container").append("<div id=" + this.tooltipId + "></div>");
    ReactDOM.render(<Tooltip widgetId={this.props.model.id}
                             metaData={this.props.model.metaData}/>, document.getElementById(this.tooltipId));
  }

  resetWidget(data) {
    WidgetService.removePreviousUserAction(this.props.model.id);

    const widget = this.getWidget();
    if (this.props.model.id === data.widgetId) {
      this.publish(InternalEvent.Dashboard.CHART_RESET, {
        id: widget.id,
        type: widget.type,
        components: this.props.components,
        title: widget.title,
        legends: widget.legends,
        metaData: widget.metaData,
        maximized: data.maximized
      })
    }
  }

  legendAltered(legends) {
    this.setState({
      legends: legends
    });
  }

  getWidget() {
    return WidgetService.getWidget(this.props.widget.id)
  }

  render() {

    if (this.state.legends == null) {
      this.state.legends = this.props.model.legends;
    }

    let component;
    for (let componentId in this.props.components) {
      component = this.props.components[componentId];
    }


    return (
      <div style={{width: '100%', height: '100%'}}>
        <Chart widget={this.props.widget} widgetId={this.props.model.id}
               metaData={this.props.model.metaData}
               legends={this.props.model.legends}
               isVertical={this.props.isVertical}/>
        <Legends widgetId={this.props.model.id}
                 legends={this.props.model.legends}
                 metaData={this.props.model.metaData}
                 onLegendChange={this.legendAltered}/>
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/timeseries-chart/timeSeriesWidget.jsx